// ReleaseNote8.jsx
import { Box, Typography } from "@mui/material";

const ReleaseNote8 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 8.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing new form support and enhancements to reference-related
        workflows in JUNE.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>

        <ul style={{ margin: 0, paddingLeft: "5%" }}>
          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>
                RCE Transmittal EFS (SB-30) Form{" "}
                <span style={{ color: "green", fontSize: "0.85em", verticalAlign: "super" }}>
                  New!
                </span>
              </strong>
              <br />
              The Patent Center-compatible version of the SB-30 form is now
              available in JUNE. Users can now select, generate, and download the
              SB-30 form as part of their workflow.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>SB-08 Generator – Enhancements</strong>
              <br />
              In addition to the existing output, the SB-08 generated package
              will now include an Excel file containing a structured list of all
              reference numbers along with their associated details, enabling
              easier tracking, review, and downstream processing.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>1449 and 892 Downloader – Enhancement</strong>
              <br />
              The module now provides access to recently filed SB-08 documents
              that may not yet have been reviewed or processed by the examiner,
              in addition to publicly available 1449 and 892 documents for U.S.
              applications.
            </Typography>
          </li>
        </ul>

        <Typography variant="body2" sx={{ mt: 1}}>
          Refer to the FAQ and Tutorial sections for more details on this feature.
        </Typography>
      </Box>
    </Box>
  );
};

export default ReleaseNote8;
